import { type IComputedWidget } from '../../../widgets/repository/computed/IComputedWidget.ts';
import { type Datatype } from '../../datatype/Datatype.ts';
import { type IReference, ReferenceType } from '../IReference.ts';
import { type IReferencePath } from '../IReferencePath.ts';

/**
 * Diversifichiamo dalla funzione getSimpleWidgetReference per ottenere le
 * reference dinamiche
 */
export function getDynamicWidgetReference(
  type: Datatype.Boolean | Datatype.Number | Datatype.Date | Datatype.String,
) {
  return (path: IReferencePath, widget: IComputedWidget): IReference => {
    return {
      type: ReferenceType.Widget,
      widgetType: widget.type,
      path,
      id: widget.id,
      code: widget.code,
      label: widget.code,
      field: {
        type,
      },
    };
  };
}
